module.exports = __webpack_public_path__ + "static/brasilia_logo-81c9586c8dbaeae8f795079018bcf225.png";